// ✅ PostCard.jsx — Bharat-Themed Individual Post Card Component
import { motion } from 'framer-motion';
import React from 'react';
import parseTags from '../utils/parseTags';

const PostCard = ({ post, onLike, onComment }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.01 }}
      className="bg-white border border-gray-200 rounded-xl shadow p-4 mb-4"
    >
      <div className="flex justify-between items-center mb-1">
        <span className="font-semibold text-green-700">{post.username}</span>
        <span className="text-sm text-gray-500">{post.time}</span>
      </div>

      <p
        className="text-gray-800 whitespace-pre-line mb-2"
        dangerouslySetInnerHTML={{ __html: parseTags(post.content) }}
      ></p>

      {post.image && (
        <img
          src={post.image}
          alt="post"
          className="rounded-lg mb-2 border max-h-64 object-contain w-full"
        />
      )}

      <p className="text-sm text-gray-500 italic">📍 {post.location}</p>

      <div className="flex gap-4 text-sm text-gray-600 mt-2">
        <button onClick={() => onLike(post.id)} className="hover:text-green-600">
          ❤️ {post.likes}
        </button>
        <button onClick={() => onComment(post.id)} className="hover:text-orange-600">
          💬 {post.comments.length}
        </button>
      </div>
    </motion.div>
  );
};

export default PostCard;
